import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function LondonUndergroundStation(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fill: "#E91640",
    d: "M1.5 9.611a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0zm8.5-5.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z"
  }), React.createElement("path", {
    fill: "#1A9BE0",
    d: "M0 7.611h20v4H0z"
  }));
}

export { LondonUndergroundStation };
//# sourceMappingURL=LondonUndergroundStation.js.map